import { defineMessage, MessageDescriptor } from 'react-intl';

interface Config {
  activePaidSubscriptions: { [index: number]: MessageDescriptor };
}

const config: Config = {
  activePaidSubscriptions: {
    30: defineMessage({ defaultMessage: 'Shore POS' }),
    31: defineMessage({ defaultMessage: 'Shore POS+' }),
    32: defineMessage({ defaultMessage: 'Shore All-In-One' }),
  },
};

export default config;
